export const GROUP_COMPONENT = 'wysiwyg.viewer.components.Group'
export const MOBILE_CONTAINER = 'mobile.core.components.Container'
